import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import JobReportView from '../../components/JobReportView';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Admin mirror of the client portal report — opened by clicking a
// Jobs-in-Progress bar on the dashboard. Shows exactly what the customer
// sees in their portal (shared JobReportView + identical backend payload).
export default function AdminClientReport() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const { getAuthHeader } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/admin/client-job-report/${jobId}`, getAuthHeader());
        if (active) setData(res.data);
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Failed to load report');
        navigate('/admin');
      } finally {
        if (active) setLoading(false);
      }
    };
    fetch();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 size={28} className="animate-spin text-purple-500" />
      </div>
    );
  }
  if (!data) return null;

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="mb-4 bg-purple-50 border border-purple-200 rounded-lg px-4 py-2 text-sm text-purple-700" data-testid="client-view-banner">
        Client view — this is exactly what the customer sees in their portal reports.
      </div>
      <JobReportView
        data={data}
        onBack={() => navigate('/admin')}
        backLabel="Back to Dashboard"
        testId="admin-client-report"
      />
    </div>
  );
}
